import { ApolloClient, InMemoryCache } from '@apollo/client'
import { SchemaLink } from '@apollo/client/link/schema'
import { DocumentNode } from 'graphql'
import { makeExecutableSchema } from 'graphql-tools'

const cache = new InMemoryCache()

// we currently type typeDefs as DocumentNode[]
// and resolvers as { [key: string]: any }
export const ApolloClientMock = ({
  typeDefs,
  resolvers,
}: {
  typeDefs: DocumentNode[]
  resolvers: {
    [key: string]: any
  }
}) =>
  new ApolloClient({
    link: new SchemaLink({
      schema: makeExecutableSchema({
        // Disbale warnings for missing resolver type
        resolverValidationOptions: { requireResolversForResolveType: false },
        typeDefs,
        resolvers,
      }),
    }),
    cache,
  })
